function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChevronDownIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4 9.24795L12 17.3334L20 9.24795L18.5541 8.00004L12 14.6239L5.44589 8.00004L4 9.24795Z",
    fill: "currentColor"
  }));
}
export function ChevronDownIconSmall(props) {
  return ___EmotionJSX(ChevronDownIcon, _extends({
    size: "small"
  }, props));
}